import { App, BackButtonListenerEvent } from '@capacitor/app';
import { IonAccordion, IonAccordionGroup, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonNote, IonRow, IonSegment, IonSegmentButton, IonText, IonToolbar, useIonAlert } from '@ionic/react'
import { closeOutline } from 'ionicons/icons';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import "./CustodialOperation.css";
import { Asset } from "../../types/types";
import AppHeader from '../AppHeader/AppHeader';

interface CustodialOperationProps extends PropsWithChildren {

  closeAction: Function;
  operation: any;
  asset: Asset


}

const CustodialOperation: React.FC<CustodialOperationProps> = (props) => {

  const { t, i18n } = useTranslation();
  const [presentAlert] = useIonAlert();

  const [pageHeader, setPageHeader] = useState<string>(t('cashout.status.page.PAGE_HEADER') as string);
  const [segmentValue, setSegmentValue] = useState('status');
  const [stepOne, setstepOne] = useState("step")
  const [steptwo, setsteptwo] = useState("step")
  const [stepThree, setstepThree] = useState("step")
  const [stepFour, setstepFour] = useState("step")

  const [stepOneName, setstepOneName] = useState<string>(t('custodial_operation.status.step1.LABEL') as string)
  const [steptwoName, setsteptwoName] = useState<string>(t('custodial_operation.status.step2.LABEL') as string)
  const [stepThreeName, setstepThreeName] = useState<string>(t('custodial_operation.status.step3.LABEL') as string)
  const [stepFourName, setstepFourName] = useState<string>(t('custodial_operation.status.step4.LABEL') as string)

  const steps = [

    {
      label: stepOneName,
      step: 1,
      className: stepOne
    },
    {
      label: steptwoName,
      step: 2,
      className: steptwo
    },
    {
      label: stepThreeName,
      step: 3,
      className: stepThree
    },
    {
      label: stepFourName,
      step: 4,
      className: stepFour
    },

  ]

  const [message, setmessage] = useState("");
  const [hideMessage, setHideMessage] = useState(true);
  const [hideSummary, setHideSummary] = useState(false);

  const presentErrorAlert = (error: any) => {

    presentAlert({
      header: 'Error',
      message: `${error.data}`,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
            return
          }
        }
      ],

    })

  }

  const segmentChanged = (value: any) => {

    setSegmentValue(value)

  }

  useEffect(() => {
    let backButtonListener: any;

    const setupBackButtonListener = async () => {
      backButtonListener = await App.addListener('backButton', (ev: BackButtonListenerEvent) => {
        props.closeAction();
      });
    };

    setupBackButtonListener();

    // Cleanup function
    return () => {
      backButtonListener?.remove();
    };
  }, [props.closeAction]);

  useEffect(() => {

    const init = async () => {

      try {

        let statusHistory = props.operation.info.status_history as any[];

        setstepOne(`step ${statusHistory[0].status}`);
        setsteptwo(`step ${statusHistory[1].status}`);
        setstepThree(`step ${statusHistory[2].status}`);
        setstepFour(`step ${statusHistory[3].status}`);

        for (let i = 0; i < statusHistory.length; i++) {

          if (statusHistory[i].status === 'error') {
            setmessage(t('custodial_operation.status.ERROR.MESSAGE') as string);
            setHideMessage(false)
            break;

          }

          if (statusHistory[i].status === 'in_progress') {
            setmessage(t('custodial_operation.status.PROCESSING.MESSAGE') as string);
            setHideMessage(false);
            break

          }

          if (statusHistory[i].status === 'completed') {
            setHideMessage(true)

          }


        }


      } catch (error) {
        presentErrorAlert({ data: t('application.uncaught.ERROR') })

      }

    }

    init();

  }, [])


  return (
    <>

      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => { props.closeAction() }} color={'primary'}>
              <IonIcon slot="icon-only" icon={closeOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>

      </IonHeader>

      <IonContent>
        <AppHeader
          title={pageHeader}

        >
        </AppHeader>

        <IonItem lines="none" className='item_custodial_op'>

          <IonSegment className="Segmentstatus" value={segmentValue} mode='ios' onIonChange={(e: any) => segmentChanged(e.detail.value)}>
            <IonSegmentButton value="status" className='SegmentstatusButton'>
              <IonLabel>{t('custodial_operation.status.ORDER_STATUS_LABEL')}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="details" className='SegmentstatusButton'>
              <IonLabel>{t('custodial_operation.status.ORDER_STATUS_DETAIL')}</IonLabel>
            </IonSegmentButton>
          </IonSegment>

        </IonItem>

       

        {
          segmentValue === 'status' ? (
            <IonGrid className='ion-padding operationGrid'>
              <IonRow>
              <ol className="steps">
                {
                  steps.map((step, index) => {
                    return (
                      <li className={step.className} key={index}>
                        {step.label}
                      </li>
                    )
                  })
                }

              </ol>

              </IonRow>
            </IonGrid>

          ) : (

        
            <IonGrid className='ion-padding'>


              <IonRow className='item_custodial_op'>
                <IonCol className='ion-text-start'>
                  <IonText className="ion-text-wrap">
                    <h5>{t('custodial_operation.status.page.ID_LABEL')}</h5>
                  </IonText>
                  <IonNote className="operationsItem_IonNote" style={{color:'var(--ion-text-color)'}}>
                    {props.operation.info.id}
                  </IonNote>
                </IonCol>
              </IonRow>

              <IonRow  className='item_custodial_op'>

                <IonCol className='ion-text-start'>
                  <IonText className="ion-text-wrap">
                    <h5>{t('custodial_operation.status.SUMMARY.DELIVERY')}</h5>
                  </IonText>

                  <IonNote className="operationsItem_IonNote" color='var(ion-text-color)'>

                    {
                      (props.operation.info.kind === "bank_transfer" || props.operation.info.kind === "giftcard") ? props.operation.info.reciever_full_name
                        :
                        (props.operation.info.kind === 'topup') ? `+${props.operation.info.reciever_account_number}`
                          :
                          (props.operation.info.kind === 'lanave') ? `${props.operation.info.reciever_account_number}`
                            :
                            `${props.operation.info.to_address}`
                    }


                  </IonNote>


                </IonCol>

              </IonRow>

              <IonRow className='item_custodial_op'>
                <IonCol className='ion-text-start'>
                  <IonText className="ion-text-wrap">
                    <h5>{t('custodial_operation.status.TYPE.LABEL')}</h5>
                  </IonText>
                  <IonNote className="operationsItem_IonNote" color='var(ion-text-color)'>
                    {
                      props.operation.info.kind === 'topup' ? t(`custodial_operation.status.TRANSACTION_TYPE.LABEL_TOPUP`)
                        : props.operation.info.kind === 'lanave' ? t(`custodial_operation.status.TRANSACTION_TYPE.LABEL_TOPUP_LANAVE`)
                          : props.operation.info.kind === 'bank_transfer' ? t(`custodial_operation.status.TRANSACTION_TYPE.LABEL_Bank`)
                            : props.operation.info.kind === 'giftcard' ? t(`custodial_operation.status.TRANSACTION_TYPE.LABEL_GIFTCARD`)
                              : props.operation.info.kind === 'buy' ? t(`custodial_operation.status.TRANSACTION_TYPE.LABEL_BUY_CRYPTO`)
                                : props.operation.info.kind === 'sell' ? t(`custodial_operation.status.TRANSACTION_TYPE.LABEL_SELL_CRYPTO`)
                                  : "Stellar Network"
                    }
                  </IonNote>
                </IonCol>

              </IonRow>

              <IonRow className='item_custodial_op' hidden={props.operation.kind !== 'giftcard'}>
                <IonCol className='ion-text-start'>
                  <IonText className="ion-text-wrap">
                    <h5>{t('custodial_operation.giftcard.details.PIN')}</h5>
                  </IonText>
                  <IonNote className="operationsItem_IonNote" color='var(ion-text-color)'>
                    {props.operation.info.external_extra_text}
                  </IonNote>

                </IonCol>

              </IonRow>

              <IonRow hidden={hideSummary} className='item_custodial_op' >
                <IonCol className='ion-text-start'>
                  <IonText className="ion-text-wrap">
                    <h5>{t('custodial_operation.status.SUMMARY.LABEL')}</h5>
                  </IonText>


                  <IonAccordionGroup 
                    expand="inset" 
                    className='AccordionStyle' 
                    value={"first"} 
                   
                    >

                    <IonAccordion value="first"  >
                      <IonItem slot="header" lines='none' color='primary' >
                        <IonLabel>
                        <b>
                          {t('custodial_operation.status.TRANSFERING.LABEL')}   {parseFloat(props.operation.info.amount_in).toFixed(2)}  {props.operation.info.asset_code}</b>
                          </IonLabel>

                      </IonItem>

                      <div className="ion-padding" slot="content" style={{ padding: "0px" }}>
                        <hr  style={{ margin: "0px" }} />
                          <IonItem lines='none'  >

                          <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {t('custodial_operation.status.WITHDRAW.LABEL')}
                          </IonNote>

                          <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {parseFloat(props.operation.info.amount_out).toFixed(2)} {props.operation.info.asset_code}

                          </IonNote>
                        </IonItem>


                        <IonItem lines='none' >

                          <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {t('custodial_operation.status.FEE.LABEL')}
                          </IonNote>

                          <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {parseFloat(props.operation.info.amount_fee).toFixed(2)} {props.operation.info.asset_code}

                          </IonNote>
                        </IonItem>

                      </div>

                    </IonAccordion>
                  </IonAccordionGroup>

                </IonCol>

              </IonRow>

            </IonGrid>
            
          )
        }

        <IonCard style={{ marginTop: "15%" }} hidden={hideMessage}>
          <IonCardContent>
            {message}
          </IonCardContent>
        </IonCard>

      </IonContent>

    </>
  )
}

export default CustodialOperation




